import { createLazyReactDirective } from '../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./Appeals')).Appeals,
  'appeals',
  {
    routeParams: '=',
  },
);
